var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-tree-container"},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.tree,"default-expand-all":"","node-key":"id","show-checkbox":"","props":_vm.defaultProps,"expand-on-click-node":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }